import React from "react";
import { Container } from "semantic-ui-react";

export function SmartContainer(props) {
  return <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>{props.children}</Container>;
}
